<template>
  <base-table :service="codeService" fetch-func="all" :fetch-params="params" :columns="$options.columns" :per-page="$options.perPage" :prepend="$options.prepend" :checkable="true" :checked="checked" @check="onCheck" :sticky="true" :infinite-scroll="true" ref="baseTable"></base-table>
</template>

<script>
import BaseTable from "@/components/partials/BaseTable";
import { AssetService } from "@/services/asset.service.js";
import { CodeService } from "@/services/code.service.js";
import { JsonDenormalizer } from "@/helpers/JsonDenormalizer.js";

export default {
  prepend: [
    {
      id: "hotspots",
      name: "Hotspots"
    }
  ],
  additionalParams: {
    includes: "assets",
    type: "ASSET"
  },
  columns: [
    {
      field: "id",
      label: "ID",
      meta: {
        hidden: true
      }
    },
    {
      field: "name",
      label: "TYPE",
      meta: {
        class: "no-wrap"
      }
    }
  ],
  perPage: 1000,
  components: {
    BaseTable
  },
  data: () => ({
    codeService: CodeService,
    params: {},
    data: [],
    checked: [],
    hotspots: []
  }),
  created() {
    this.setParams();
  },
  watch: {
    data: {
      handler: function(value) {
        this.$emit("update:total", this.getAssets(value).length);
      },
      deep: true
    }
  },
  methods: {
    async fetch() {
      this.data = await this.$refs.baseTable.fetchData();
    },
    setParams() {
      this.params = {
        ...this.$options.additionalParams
      };
    },
    async onCheck(checked) {
      let assets = [];

      if (checked.find(asset => asset.id === "hotspots")) {
        // Avoid refetching hotspots every time user checks
        if (this.hotspots.length === 0) {
          this.$refs.baseTable.loading = true;
          this.hotspots = await this.fetchHotspots();
          this.$refs.baseTable.loading = false;
        }
      } else {
        this.hotspots = [];
      }

      assets = this.getAssets(checked);
      assets = assets.concat(this.hotspots);

      this.checked = checked;
      this.$emit("check", assets);
    },
    getAssets(codes) {
      return codes.reduce((acc, code) => {
        if (code.assets) {
          const { assets, color, ...rest } = code;

          assets.forEach(asset => {
            acc.push({
              ...asset,
              code: rest,
              options: {
                color,
                opacity: 0.75
              }
            });
          });
        }
        return acc;
      }, []);
    },
    async fetchHotspots() {
      const response = await AssetService.all({ includes: "code", hotspot: 1 });
      let assets = JsonDenormalizer.denormalize(response);

      return assets.map(asset => {
        asset.options = {
          color: "#ffd83d",
          opacity: 0.75
        };
        return asset;
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/pages/Assets/list/partials/tableClass.vue